export const environment = {
    dev: true,
    production: false,
    staging: false,
    apiUrl: 'https://mddevapi.flexnow.care/api/v1/platform',
    //apiUrl: 'https://localhost:44351/api/v1/platform',
    apiInterval: 60000,
    FIREBASE_API_KEY:'AIzaSyClv01DNBE-m01A0Lvx4yxsgUor1ToCiO4',
    apiFireBaseUrl: 'https://identitytoolkit.googleapis.com',
    apiFirebaseLoginUrl: 'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=%s',
    ClientSecretKey: 'QWRtaW5TaWRlQVBJ',
    ClientId: 'AdminSideAPI',
    firebase:{
      apiKey: "AIzaSyClv01DNBE-m01A0Lvx4yxsgUor1ToCiO4",
      authDomain: "move-78-dev.firebaseapp.com",
      projectId: "move-78-dev",
      storageBucket: "move-78-dev.appspot.com",
      messagingSenderId: "783700822824",
      appId: "1:783700822824:web:06a470c0d317902b701e1d",
      measurementId: "G-J26XZZE83G"
    },
    oneSignal: {
      appId: "0e204333-6791-4eb5-8283-2a24aeb40ceb"
    }, 
    openTok: {
      API_KEY: '',
      SESSION_ID: '',
      TOKEN: ''      
    }
};
